// Google Analytics 4 helper
// Veilig wrapper rond window.gtag — doet niets als gtag (nog) niet bestaat.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export type GAEventParams = Record<string, string | number | boolean | null | undefined>;

export const trackEvent = (name: string, params: GAEventParams = {}) => {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    // stil falen — analytics mag nooit de app breken
  }
};
